import {
  getPostApiV1ThreeLetterCodeClientAdminsBranchesMutationFetcher,
  getPostApiV1ThreeLetterCodeClientAdminsBranchesMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { useMutation } from '@fukuri-admins/hooks/common';
import { type AxiosError } from 'axios';

export const usePostBranch = (
  threeLetterCode: string,
  options?: {
    onSuccess?: () => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) =>
  useMutation(
    getPostApiV1ThreeLetterCodeClientAdminsBranchesMutationKey(threeLetterCode),
    getPostApiV1ThreeLetterCodeClientAdminsBranchesMutationFetcher(threeLetterCode),
    options
  );
